import Vue from 'vue';
import Vuex from 'vuex';
import * as login from './modules/login';
import advancedService from './modules/advancedService';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    ...login, // 登录模块
    advancedService
  }
});
